/* eslint-disable max-statements */
import React, { useState, useEffect } from "react";
import styles from "./styles.css";
import Financing from "./images/financing-not-found.png";
import Credit from "./images/credit-meter.png";
import Arrow from "./images/arrow.png";
import Button from "../../shared/button";
import PropTypes from "prop-types";
import { useHistory } from "react-router";
import FinancingCfExpired from "../pre-approval-financing-flow/financing-cf-expired";
import { BOOL_STATE, LOAN_ERROR } from "../../../constants/checkout-constants";
import { CAR_LIST_EVENT_NAMES, NUMBER } from "../../../constants/app-constants";
// import FinanceViewCars from "../../au.mobile/pre-approval-financing-flow/finance-view-cars";
import PreApprovalReadDetails from "../pre-approval-financing-flow/pre-approval-read-details";
//import PreApprovalEditContainer from "../pre-approval-financing-flow/pre-approval-edit-container";
import FinancingCfRejected from "../pre-approval-financing-flow/financing-cf-rejected";
import { trackDesktopCustomEventsAU, sendCustomGaEvents } from "../../../tracking";
import { EVENT_DATA } from "./tracking";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import FinancingZeroDeposit from "../financing-zero-deposit";
import PreApprovalPersonalReadDetails from "../pre-approval-financing-flow/pre-approval-personal-read-details";
import { appUrl } from "../../../constants/url-constants";
import { getAbExpirementVariant } from "../../../utils/helpers/get-ab-expirement-variant";
import { EXPERIMENT_TYPE } from "../../../constants/optimize-constants";

const FinancingNotFound = ({
    financeData,
    //preApproved,
    financeErrorResponse,
    setPreApprovalEditModeConnect,
    setPreApprovedOriginConnect,
    isUserZeroDpVariant,
    financeQuotes,
    creditScore,
    preApprovalOnFlyDesktop,
    startPreApprovalOnFlyConnect
}) => {
    const { loanType } = financeData || {};
    const { isPurposeBusiness } = loanType || {};
    const preApproved = (financeQuotes || []).length > 0;
    const history = useHistory();
    const [showEdit, setShowEdit] = useState(false);

    const handlePreApproved = () => {
        setPreApprovedOriginConnect(CAR_LIST_EVENT_NAMES.MY_ACCOUNT);
        history.push("/financing/get-pre-approval");
    };

    const handleRejectionEdit = () => {
        const isOnFlyVariant = getAbExpirementVariant(preApprovalOnFlyDesktop, EXPERIMENT_TYPE.VARIANT_B);
        if (isOnFlyVariant && startPreApprovalOnFlyConnect) {
            startPreApprovalOnFlyConnect({
                entryPoint: "pre-approval-my-account-edit",
                isEditFlow: true,
                reloadOnClose: true
            });
            return;
        }
        setPreApprovalEditModeConnect(true);
        history.push("/my-account/financing/loan-details");
    };

    useEffect(() => {
        if (financeErrorResponse && financeErrorResponse.errorCode === LOAN_ERROR.EXPIRED) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.PRE_APPROVAl_REJECTED);
        } else if (financeErrorResponse && financeErrorResponse.errorCode) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.PRE_APPROVAl_REJECTED);
        } else if (preApproved) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.PRE_APPROVAl_SUCCESS);
        }
    }, [financeErrorResponse, preApproved, showEdit]);

    useEffect(() => {
        let eventLabel;
        if (creditScore >= NUMBER.SIX_HUNDRED) {
            eventLabel = "Prime_greater_than_600_CS";
        } else if (creditScore >= NUMBER.FIVE_HUNDRED) {
            eventLabel = "Midprime_between_500_and_600_CS";
        } else {
            eventLabel = "Subprime_less_than_500_CS";
        }
        sendCustomGaEvents({
            ...EVENT_DATA.CREDIT_SCORE,
            eventLabel
        });
    }, [creditScore]);

    const displayData = () => {
        if (preApproved) {
            if (isPurposeBusiness === BOOL_STATE.NO) {
                return (
                    <div styleName={"styles.preApprovalWrapper"}>
                        <PreApprovalPersonalReadDetails
                            handleEditcallback={handleRejectionEdit}
                        />
                    </div>
                );
            }
            return (
                <div styleName={"styles.preApprovalWrapper"}>
                    <PreApprovalReadDetails
                        handleEditcallback={handleRejectionEdit}
                    />
                </div>
            );
        } else if (financeErrorResponse && financeErrorResponse.errorCode === LOAN_ERROR.EXPIRED) {
            return <FinancingCfExpired handleEditcallback={setShowEdit} />;
        } else if (financeErrorResponse && financeErrorResponse.errorCode) {
            return <FinancingCfRejected handleEditcallback={handleRejectionEdit} />;
        } else if (isUserZeroDpVariant) {
            return (
                <FinancingZeroDeposit handlePreApproval={handlePreApproved} />
            );
        }
        return (
            <div styleName={"styles.outer"}>
                <h3 styleName={"styles.header"}>Financing with Cars24</h3>
                <img src={Financing} alt="Financing with Cars24" />
                <div styleName={"styles.noImpactWrap"}>
                    <p styleName={"styles.noImpact"}><img src={Credit} alt="Credit Score" />No impact on credit score</p>
                </div>
                <p styleName={"styles.detailText"}>Financing with Cars24 makes it even easier to get into the car that's
                    right for you. By being pre-approved for a loan, you can browse
                        from our expansive inventory of vehicles with completely personalised
                        financing terms
                </p>
                <div styleName={"styles.seeHowWrap"}>
                    <a target="_blank" href={`${appUrl()}/cars24-finance`} styleName={"styles.seeHow"}>See how our finance works <img src={Arrow} alt="Arrow" /></a>
                </div>
                <div styleName={"styles.buttonWrapper"}>
                    <Button text="GET PRE-APPROVED" onClick={handlePreApproved}/>
                </div>
            </div>
        );
    };

    return (
        <React.Fragment>
            {displayData()}
        </React.Fragment>
    );
};

FinancingNotFound.propTypes = {
    getPreApprovalLoanDetailsConnect: PropTypes.func,
    updatePreApprovalLoanConnect: PropTypes.func,
    setPreApprovedOriginConnect: PropTypes.func,
    setPreApprovalEditModeConnect: PropTypes.func,
    getPreApprovalQuestionsConnect: PropTypes.func,
    preApproved: PropTypes.bool,
    financeErrorResponse: PropTypes.object,
    isLoggedIn: PropTypes.bool,
    isUserZeroDpVariant: PropTypes.bool,
    financeData: PropTypes.object,
    maxDeposit: PropTypes.object,
    preApprovalQuestions: PropTypes.object,
    getPreApprovalFormProgressConnect: PropTypes.func,
    financeQuotes: PropTypes.array,
    creditScore: PropTypes.number,
    preApprovalOnFlyDesktop: PropTypes.object,
    startPreApprovalOnFlyConnect: PropTypes.func
};

export default FinancingNotFound;
